// Libs
import React, { ReactElement, forwardRef, Ref } from 'react';
import { Icon, Typography } from 'ui-components';
import clsx from 'clsx';
// App
import styles from './add-item-card-button.module.scss';
import { AddItemCardButtonProps } from './add-item-card-button.interfaces';

/**
 * Displays a button for adding an item
 * @param props
 */
const AddItemCardButton = forwardRef(
  (props: AddItemCardButtonProps, ref: Ref<HTMLDivElement>): ReactElement => {
    const { label = 'Ajouter' } = props;

    return (
      <div {...props} ref={ref} className={clsx(styles.button, props.className)}>
        <Icon name="plus" className={styles.addIcon} size="large"></Icon>
        <Typography mt={1} variant="h4" align="center">
          {label}
        </Typography>
      </div>
    );
  }
);

export default AddItemCardButton;
